module.exports = __webpack_public_path__ + "08ab4c8620f59a1959148b69a681c8b7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppfPreview/low_28.jpg
// module id = 1739
// module chunks = 5